import CarrierAdminAFKL from 'shared/Header/utils/CarrierAdmin_AFKL'
import CarrierAdminAI from 'shared/Header/utils/CarrierAdmin_AI'
import CarrierAdminAC from 'shared/Header/utils/CarrierAdmin_AC'
import CarrierAdminAA from 'shared/Header/utils/CarrierAdmin_AA'
import CarrierAdminMH from 'shared/Header/utils/CarrierAdmin_MH'
import CarrierAdminNZ from 'shared/Header/utils/CarrierAdmin_NZ'
import CarrierAdminSK from 'shared/Header/utils/CarrierAdmin_SK'
import CarrierAdminUA from 'shared/Header/utils/CarrierAdmin_UA'
import CarrierAdminUW from 'shared/Header/utils/CarrierAdmin_UW'
import CarrierAdminAZ from 'shared/Header/utils/CarrierAdmin_AZ'
import CarrierAdminQR from 'shared/Header/utils/CarrierAdmin_QR'
import {
    CarrierAdminUserManagementAccess,
    CarrierAdminUserManagementPrevilages,
    deafultCarrierUserManagementPrevilages,
    type ICarrierAdminUserManagementAuthorizationConfig
} from 'shared/Header/utils/CarrierAdminUserManagement'
import {
    CarrierAdminToolsAccess,
    CarrierAdminToolsPrevilages,
    deafultCarrierToolsPrevilages,
    type ICarrierAdminToolsAuthorizationConfig
} from 'shared/Header/utils/CarrierAdminTools'
import {ENDPOINT} from 'config/path'
import CarrierAdmin8D from 'shared/Header/utils/CarrierAdmin_8D'

export interface TMenuItem {
    title: string
    pathname?: string
    authPrevilege: string
    subMenus?: TMenuItem[]
    badge?: string
    subTitle?: string
    divider?: boolean
}

export interface ICarrierAdminAuthorizationConfig {
    isAministratorStatus: boolean
    isLevelofAdminRight: boolean
    isGSAStatus: boolean
    isAllocation: boolean
    isRating: boolean
}

export interface IServiceAdminUserAuthorizationConfig {
    isBranchMemberStatus: boolean
    isBranchAdministratorStatus: boolean
    isCoLoaderStatus: boolean
    isBookingAuthorization: boolean
    isRateAuthorization: boolean
    isAllocationAuthorization: boolean
}

export const MENU_ITEMS: TMenuItem[] = [
    {
        title: 'Offers',
        pathname: '/',
        authPrevilege: 'OfferMenu',
        subMenus: [
            {
                title: 'Request a SPOT Rate',
                pathname: '/lmsweb/secure/spot_pricing.jsp',
                authPrevilege: 'RequestASpotRate'
            },
            {
                title: 'AC SPOT Rate Offers',
                pathname: '/lmsweb/secure/carrierspotoffers.jsp?selCarrier=AC&hidSpotcacc=',
                authPrevilege: 'ACSpotRateOffers'
            },
            {
                title: 'AI SPOT Rate Offers',
                pathname: '/lmsweb/secure/carrierspotoffers.jsp?selCarrier=AI&hidSpotcacc=',
                authPrevilege: 'AISpotRateOffers'
            },
            {
                title: 'MH SPOT Rate Offers',
                pathname: '/lmsweb/secure/carrierspotoffers.jsp?selCarrier=MH&hidSpotcacc=',
                authPrevilege: 'MHSpotRateOffers'
            },
            {
                title: 'NZ SPOT Rate Offers',
                pathname: '/lmsweb/secure/carrierspotoffers.jsp?selCarrier=NZ&hidSpotcacc=',
                authPrevilege: 'NZSpotRateOffers'
            },
            {
                title: 'SK SPOT Rate Offers',
                pathname: '/lmsweb/secure/carrierspotoffers.jsp?selCarrier=SK&hidSpotcacc=',
                authPrevilege: 'SKSpotRateOffers'
            },
            {
                title: 'UW SPOT Rate Offers',
                pathname: '/lmsweb/secure/carrierspotoffers.jsp?selCarrier=UW&hidSpotcacc=',
                authPrevilege: 'UWSpotRateOffers'
            }
        ]
    },
    {
        title: 'Marketplace',
        pathname: `${ENDPOINT.marketPlace}`,
        authPrevilege: 'Marketplace'
    },
    {
        title: 'Booking',
        pathname: '/',
        authPrevilege: 'Booking',
        subMenus: [
            {
                title: 'Book cargo',
                pathname: 'secure/booking',
                authPrevilege: 'CreateModifyBookingNew',
                badge: 'NEW',
                subTitle: 'Easily create and modify bookings',
                divider: true
            },
            {
                title: 'Search Availability and Price',
                pathname: '/lmsweb/secure/advancedrate.jsp',
                authPrevilege: 'SearchAvailabilityAndPrice'
            },
            {
                title: 'Search Available Space',
                pathname: '/lmsweb/secure/availability.jsp',
                authPrevilege: 'SearchAvailableSpace'
            },
            {
                title: 'Search Air Waybill Stock',
                pathname: '/lmsweb/secure/awb-stock-status.jsp',
                authPrevilege: 'SearchAirWaybillStock'
            },
            {
                title: 'Create / Modify Booking',
                pathname: '/lmsweb/secure/booking-create.jsp',
                authPrevilege: 'CreateModifyBookingOld'
            },
            {
                title: 'Create Multiple Bookings',
                pathname: '/lmsweb/secure/booking-multiple.jsp',
                authPrevilege: 'CreateMultipleBookings'
            },
            {
                title: 'Create / Modify Booking Templates',
                pathname: '/lmsweb/secure/booking-template.jsp',
                authPrevilege: 'CreateModifyBookingTemplates'
            },
            {
                title: 'Create Recurring Booking Template',
                pathname: '/lmsweb/secure/recurringbookingtemplate.jsp',
                authPrevilege: 'CreateRecurringBookingTemplate'
            },
            {
                title: 'Create Spreadsheet Bookings',
                pathname: '/lmsweb/secure/multiCarrierXlsxBooking.jsp',
                authPrevilege: 'CreateSpreadsheetBookings'
            },
            {
                title: 'Create Air Waybill Stock Request',
                pathname: '/lmsweb/secure/awb-stock-request.jsp',
                authPrevilege: 'CreateAirWaybillStockRequest'
            },
            {
                title: 'Create Allotment Request',
                pathname: '/lmsweb/secure/requestallotments.jsp',
                authPrevilege: 'CreateAllotmentRequest'
            },
            {
                title: 'View Allotment Status',
                pathname: '/lmsweb/secure/allocation.jsp',
                authPrevilege: 'ViewAllotmentStatus'
            },
            {
                title: 'View Rate Estimate',
                pathname: '/lmsweb/secure/advancedrateestimate.jsp',
                authPrevilege: 'ViewRateEstimate'
            },
            {
                title: 'View Carrier Schedules',
                pathname: '/lmsweb/flight_schedules.jsp',
                authPrevilege: 'ViewCarrierSchedules'
            }
        ]
    },
    {
        title: 'e-Freight',
        pathname: '/',
        authPrevilege: 'Efreight',
        subMenus: [
            {
                title: 'Create / Retrieve MAWB',
                pathname: '/lmsweb/secure/retrieve-mawb.jsp',
                authPrevilege: 'CreateRetrieveMAWB'
            },
            {
                title: 'Retrieve e-Docs',
                pathname: '/lmsweb/secure/retrieve-edocs.jsp',
                authPrevilege: 'RetrieveeDocs'
            },
            {
                title: 'Create / Modify HAWB',
                pathname: '/lmsweb/secure/customs.jsp',
                authPrevilege: 'CreateModifyHAWB'
            },
            {
                title: 'Create / Modify HAWB Templates',
                pathname: '/lmsweb/secure/hawb-template.jsp?btnHawbList=Y&optUserId=BRANCH',
                authPrevilege: 'CreateModifyHAWBTemplates'
            },
            {
                title: 'Create / Modify PieceID Info',
                pathname: '/lmsweb/secure/piecedetails.jsp',
                authPrevilege: 'CreateModifyPieceIDInfo'
            }
        ]
    },
    {
        title: 'Manage Shipments',
        pathname: '/',
        authPrevilege: 'ManageShipments',
        subMenus: [
            {
                title: 'Track Shipments',
                authPrevilege: 'TrackShipments',
                pathname: '/lmsweb/tracking-awb.jsp'
            },
            {
                title: 'Search Air Waybills',
                authPrevilege: 'SearchAirWaybills',
                pathname: '/lmsweb/secure/tracking-search.jsp'
            },
            {
                title: 'View / Modify Booking',
                authPrevilege: 'ViewModifyBooking',
                pathname: '/lmsweb/secure/booking-modify.jsp'
            },
            {
                title: 'Review Active / Queued Bookings',
                authPrevilege: 'ReviewActiveQueuedBookings',
                pathname: '/lmsweb/secure/booking-summary.jsp'
            },
            {
                title: 'Print Barcode Shipping Label',
                authPrevilege: 'PrintBarcodeShippingLabel',
                pathname: '/lmsweb/secure/booking-print.jsp'
            },
            {
                title: 'Print Shipper Letter Of Instruction',
                authPrevilege: 'PrintShipperLetterOfInstruction',
                pathname: '/lmsweb/secure/booking-printsli.jsp'
            },
            {
                title: 'Make Online Payments',
                authPrevilege: 'MakeOnlinePayments',
                pathname: '/lmsweb/secure/booking-freight.jsp'
            },
            {
                title: 'View Flight Status',
                authPrevilege: 'ViewFlightStatus',
                pathname: '/lmsweb/flight_status.jsp'
            },
            {
                title: 'View Customs Status',
                authPrevilege: 'ViewCustomsStatus',
                pathname: '/lmsweb/customs-status.jsp'
            },
            {
                title: 'View Archived Air Waybill',
                authPrevilege: 'ViewArchivedAirWaybill',
                pathname: '/lmsweb/secure/archivedshipments.jsp'
            },
            {
                title: 'Shipment Release Declaration',
                authPrevilege: 'ShipmentReleaseDeclaration',
                pathname: '/lmsweb/secure/declaration.jsp'
            }
        ]
    },
    // As per Sabari's confrmation commenting below code for OCT release
    {
        title: 'e-Docs',
        pathname: '/',
        authPrevilege: 'eDocs',
        subMenus: [
            {
                title: 'My Booking Documents',
                authPrevilege: 'MyBookingDocuments',
                pathname: '/lmsweb/secure/document_dashboard_view.jsp'
            },
            {
                title: 'Air Waybill Documents',
                authPrevilege: 'AirWaybillDocuments',
                pathname: '/lmsweb/secure/document_view.jsp'
            }
        ]
    },
    {
        title: 'e-Finance',
        pathname: '/',
        authPrevilege: 'e-Finance',
        subMenus: [
            {
                title: 'View Invoices',
                authPrevilege: 'ViewInvoices',
                pathname: '/lmsweb/secure/invoiceinformation.jsp'
            },
            {
                title: 'View Payment Details',
                authPrevilege: 'ViewPaymentDetails',
                pathname: '/lmsweb/secure/paymentinformation.jsp'
            }
        ]
    },
    {
        title: 'e-Claims',
        pathname: '/',
        authPrevilege: 'eClaims',
        subMenus: [
            {
                title: 'Create / Modify Preliminary Claim',
                authPrevilege: 'CreateModifyPreliminaryClaim',
                pathname: '/lmsweb/secure/filepreliminaryclaim.jsp'
            },
            {
                title: 'Create / Modify Final Claim',
                authPrevilege: 'CreateModifyFinalClaim',
                pathname: '/lmsweb/secure/filefinalclaim.jsp'
            }
        ]
    }
]
export const AA_MENU_ITEMS: TMenuItem[] = [
    {
        title: 'Offers',
        pathname: '/',
        authPrevilege: 'OfferMenu',
        subMenus: [
            {
                title: 'Manage AA SPOT Rate Offers',
                pathname: '/lmsweb/secure/managespotrate.jsp',
                authPrevilege: 'ManageAASpotRATEOffers'
            },
            {
                title: 'View AA SPOT Offer Queue',
                pathname: '/lmsweb/secure/sraqueue.jsp?selCarrier=AA',
                authPrevilege: 'ViewAASPOTofferqueue'
            }
        ]
    },
    {
        title: 'Marketplace',
        pathname: `${`${ENDPOINT.marketPlace}`}`,
        authPrevilege: 'Marketplace'
    },
    {
        title: 'Booking',
        pathname: '/',
        authPrevilege: 'Booking',
        subMenus: [
            {
                title: 'Book cargo',
                pathname: 'secure/booking',
                authPrevilege: 'CreateModifyBookingNew',
                badge: 'NEW',
                subTitle: 'Easily create and modify bookings',
                divider: true
            },
            {
                title: 'Search Available Space',
                pathname: '/lmsweb/secure/availability.jsp',
                authPrevilege: 'SearchAvailableSpace'
            },
            {
                title: 'Search Air Waybill Stock',
                pathname: '/lmsweb/secure/awb-stock-status.jsp',
                authPrevilege: 'SearchAirWaybillStock'
            },
            {
                title: 'Create / Modify Booking',
                pathname: '/lmsweb/secure/booking-create.jsp',
                authPrevilege: 'CreateModifyBookingOld'
            },
            {
                title: 'Create Multiple Bookings',
                pathname: '/lmsweb/secure/booking-multiple.jsp',
                authPrevilege: 'CreateMultipleBookings'
            },
            {
                title: 'Create / Modify Booking Templates',
                pathname: '/lmsweb/secure/booking-template.jsp',
                authPrevilege: 'CreateModifyBookingTemplates'
            },
            {
                title: 'Create Spreadsheet Bookings',
                pathname: '/lmsweb/secure/multiCarrierXlsxBooking.jsp',
                authPrevilege: 'CreateSpreadsheetBookings'
            },
            {
                title: 'Create Air Waybill Stock Request',
                pathname: '/lmsweb/secure/awb-stock-request.jsp',
                authPrevilege: 'CreateAirWaybillStockRequest'
            },
            {
                title: 'Create Allotment Request',
                pathname: '/lmsweb/secure/requestallotments.jsp',
                authPrevilege: 'CreateAllotmentRequest'
            },
            {
                title: 'View Allotment Status',
                pathname: '/lmsweb/secure/allocation.jsp',
                authPrevilege: 'ViewAllotmentStatus'
            },
            {
                title: 'View Rate Estimate',
                pathname: '/lmsweb/secure/advancedrateestimate.jsp',
                authPrevilege: 'ViewRateEstimate'
            },
            {
                title: 'View Carrier Schedules',
                pathname: '/lmsweb/flight_schedules.jsp',
                authPrevilege: 'ViewCarrierSchedules'
            }
        ]
    },
    {
        title: 'e-Freight',
        pathname: '/',
        authPrevilege: 'Efreight',
        subMenus: [
            {
                title: 'Create / Retrieve MAWB',
                pathname: '/lmsweb/secure/retrieve-mawb.jsp',
                authPrevilege: 'CreateRetrieveMAWB'
            },
            {
                title: 'Retrieve e-Docs',
                pathname: '/lmsweb/secure/retrieve-edocs.jsp',
                authPrevilege: 'RetrieveeDocs'
            },
            {
                title: 'Create / Modify HAWB',
                pathname: '/lmsweb/secure/customs.jsp',
                authPrevilege: 'CreateModifyHAWB'
            },
            {
                title: 'Create / Modify HAWB Templates',
                pathname: '/lmsweb/secure/hawb-template.jsp?btnHawbList=Y&optUserId=BRANCH',
                authPrevilege: 'CreateModifyHAWBTemplates'
            },
            {
                title: 'Create / Modify PieceID Info',
                pathname: '/lmsweb/secure/piecedetails.jsp',
                authPrevilege: 'CreateModifyPieceIDInfo'
            }
        ]
    },
    {
        title: 'Manage Shipments',
        pathname: '/',
        authPrevilege: 'ManageShipments',
        subMenus: [
            {
                title: 'Track Shipments',
                authPrevilege: 'TrackShipments',
                pathname: '/lmsweb/tracking-awb.jsp'
            },
            {
                title: 'Search Air Waybills',
                authPrevilege: 'SearchAirWaybills',
                pathname: '/lmsweb/secure/tracking-search.jsp'
            },
            {
                title: 'View / Modify Booking',
                authPrevilege: 'ViewModifyBooking',
                pathname: '/lmsweb/secure/booking-modify.jsp'
            },
            {
                title: 'Review Active / Queued Bookings',
                authPrevilege: 'ReviewActiveQueuedBookings',
                pathname: '/lmsweb/secure/booking-summary.jsp'
            },
            {
                title: 'Print Barcode Shipping Label',
                authPrevilege: 'PrintBarcodeShippingLabel',
                pathname: '/lmsweb/secure/booking-print.jsp'
            },
            {
                title: 'Print Shipper Letter Of Instruction',
                authPrevilege: 'PrintShipperLetterOfInstruction',
                pathname: '/lmsweb/secure/booking-printsli.jsp'
            },
            {
                title: 'Make Online Payments',
                authPrevilege: 'MakeOnlinePayments',
                pathname: '/lmsweb/secure/booking-freight.jsp'
            },
            {
                title: 'View Flight Status',
                authPrevilege: 'ViewFlightStatus',
                pathname: '/lmsweb/flight_status.jsp'
            },
            {
                title: 'View Customs Status',
                authPrevilege: 'ViewCustomsStatus',
                pathname: '/lmsweb/customs-status.jsp'
            },
            {
                title: 'View Archived Air Waybill',
                authPrevilege: 'ViewArchivedAirWaybill',
                pathname: '/lmsweb/secure/archivedshipments.jsp'
            }
        ]
    },
    {
        title: 'e-Claims',
        pathname: '/',
        authPrevilege: 'eClaims',
        subMenus: [
            {
                title: 'File Damage Report',
                authPrevilege: 'FileDamageReport',
                pathname: '/lmsweb/secure/damagereport.jsp'
            },
            {
                title: 'View Damage Report Status',
                authPrevilege: 'ViewDamageReportStatus',
                pathname: '/lmsweb/secure/damagereportstatus.jsp'
            },
            {
                title: 'Create / Modify Preliminary Claim',
                authPrevilege: 'CreateModifyPreliminaryClaim',
                pathname: '/lmsweb/secure/filepreliminaryclaim.jsp'
            },
            {
                title: 'Create / Modify Final Claim',
                authPrevilege: 'CreateModifyFinalClaim',
                pathname: '/lmsweb/secure/filefinalclaim.jsp'
            }
        ]
    }
]
export const AC_MENU_ITEMS: TMenuItem[] = [
    {
        title: 'Offers',
        pathname: '/',
        authPrevilege: 'OfferMenu',
        subMenus: [
            {
                title: 'Manage AC SPOT Rate Offers',
                pathname: '/lmsweb/secure/managespotrate.jsp',
                authPrevilege: 'ManageACSpotRATEOffers'
            },
            {
                title: 'View AC SPOT Offer Queue',
                pathname: '/lmsweb/secure/sraqueue.jsp?selCarrier=AC',
                authPrevilege: 'ViewACSPOTofferqueue'
            }
        ]
    },
    {
        title: 'Marketplace',
        pathname: `${ENDPOINT.marketPlace}`,
        authPrevilege: 'Marketplace'
    },
    {
        title: 'Booking',
        pathname: '/',
        authPrevilege: 'Booking',
        subMenus: [
            {
                title: 'Book cargo',
                pathname: 'secure/booking',
                authPrevilege: 'CreateModifyBookingNew',
                badge: 'NEW',
                subTitle: 'Easily create and modify bookings',
                divider: true
            },
            {
                title: 'Search Availability and Price',
                pathname: '/lmsweb/secure/advancedrate.jsp',
                authPrevilege: 'SearchAvailabilityAndPrice'
            },
            {
                title: 'Search Available Space',
                pathname: '/lmsweb/secure/availability.jsp',
                authPrevilege: 'SearchAvailableSpace'
            },
            {
                title: 'Search Air Waybill Stock',
                pathname: '/lmsweb/secure/awb-stock-status.jsp',
                authPrevilege: 'SearchAirWaybillStock'
            },
            {
                title: 'Create / Modify Booking',
                pathname: '/lmsweb/secure/booking-create.jsp',
                authPrevilege: 'CreateModifyBookingOld'
            },
            {
                title: 'Create Multiple Bookings',
                pathname: '/lmsweb/secure/booking-multiple.jsp',
                authPrevilege: 'CreateMultipleBookings'
            },
            {
                title: 'Create / Modify Booking Templates',
                pathname: '/lmsweb/secure/booking-template.jsp',
                authPrevilege: 'CreateModifyBookingTemplates'
            },
            {
                title: 'Create Spreadsheet Bookings',
                pathname: '/lmsweb/secure/multiCarrierXlsxBooking.jsp',
                authPrevilege: 'CreateSpreadsheetBookings'
            },
            {
                title: 'Create Air Waybill Stock Request',
                pathname: '/lmsweb/secure/awb-stock-request.jsp',
                authPrevilege: 'CreateAirWaybillStockRequest'
            },
            {
                title: 'Create Allotment Request',
                pathname: '/lmsweb/secure/requestallotments.jsp',
                authPrevilege: 'CreateAllotmentRequest'
            },
            {
                title: 'View Allotment Status',
                pathname: '/lmsweb/secure/allocation.jsp',
                authPrevilege: 'ViewAllotmentStatus'
            },
            {
                title: 'View Rate Estimate',
                pathname: '/lmsweb/secure/advancedrateestimate.jsp',
                authPrevilege: 'ViewRateEstimate'
            },
            {
                title: 'View Carrier Schedules',
                pathname: '/lmsweb/flight_schedules.jsp',
                authPrevilege: 'ViewCarrierSchedules'
            },
            {
                title: 'Update Air Waybill Status',
                pathname: '/lmsweb/secure/status_update.jsp',
                authPrevilege: 'UpdateAirWaybillStatus'
            }
        ]
    },
    {
        title: 'e-Freight',
        pathname: '/',
        authPrevilege: 'Efreight',
        subMenus: [
            {
                title: 'Create / Retrieve MAWB',
                pathname: '/lmsweb/secure/retrieve-mawb.jsp',
                authPrevilege: 'CreateRetrieveMAWB'
            },
            {
                title: 'Retrieve e-Docs',
                pathname: '/lmsweb/secure/retrieve-edocs.jsp',
                authPrevilege: 'RetrieveeDocs'
            },
            {
                title: 'Create / Modify HAWB',
                pathname: '/lmsweb/secure/customs.jsp',
                authPrevilege: 'CreateModifyHAWB'
            },
            {
                title: 'Create / Modify HAWB Templates',
                pathname: '/lmsweb/secure/hawb-template.jsp?btnHawbList=Y&optUserId=BRANCH',
                authPrevilege: 'CreateModifyHAWBTemplates'
            },
            {
                title: 'Create / Modify PieceID Info',
                pathname: '/lmsweb/secure/piecedetails.jsp',
                authPrevilege: 'CreateModifyPieceIDInfo'
            }
        ]
    },
    {
        title: 'Manage Shipments',
        pathname: '/',
        authPrevilege: 'ManageShipments',
        subMenus: [
            {
                title: 'Track Shipments',
                authPrevilege: 'TrackShipments',
                pathname: '/lmsweb/tracking-awb.jsp'
            },
            {
                title: 'Search Air Waybills',
                authPrevilege: 'SearchAirWaybills',
                pathname: '/lmsweb/secure/tracking-search.jsp'
            },
            {
                title: 'View / Modify Booking',
                authPrevilege: 'ViewModifyBooking',
                pathname: '/lmsweb/secure/booking-modify.jsp'
            },
            {
                title: 'Review Active / Queued Bookings',
                authPrevilege: 'ReviewActiveQueuedBookings',
                pathname: '/lmsweb/secure/booking-summary.jsp'
            },
            {
                title: 'Print Barcode Shipping Label',
                authPrevilege: 'PrintBarcodeShippingLabel',
                pathname: '/lmsweb/secure/booking-print.jsp'
            },
            {
                title: 'Print Shipper Letter Of Instruction',
                authPrevilege: 'PrintShipperLetterOfInstruction',
                pathname: '/lmsweb/secure/booking-printsli.jsp'
            },
            {
                title: 'Make Online Payments',
                authPrevilege: 'MakeOnlinePayments',
                pathname: '/lmsweb/secure/booking-freight.jsp'
            },
            {
                title: 'View Flight Status',
                authPrevilege: 'ViewFlightStatus',
                pathname: '/lmsweb/flight_status.jsp'
            },
            {
                title: 'View Customs Status',
                authPrevilege: 'ViewCustomsStatus',
                pathname: '/lmsweb/customs-status.jsp'
            },
            {
                title: 'View Archived Air Waybill',
                authPrevilege: 'ViewArchivedAirWaybill',
                pathname: '/lmsweb/secure/archivedshipments.jsp'
            },
            {
                title: 'Shipment Release Declaration',
                authPrevilege: 'ShipmentReleaseDeclaration',
                pathname: '/lmsweb/secure/declaration.jsp'
            }
        ]
    },
    {
        title: 'e-Claims',
        pathname: '/',
        authPrevilege: 'eClaims',
        subMenus: [
            {
                title: 'File Damage Report',
                authPrevilege: 'FileDamageReport',
                pathname: '/lmsweb/secure/damagereport.jsp'
            },
            {
                title: 'View Damage Report Status',
                authPrevilege: 'ViewDamageReportStatus',
                pathname: '/lmsweb/secure/damagereportstatus.jsp'
            },
            {
                title: 'Create / Modify Preliminary Claim',
                authPrevilege: 'CreateModifyPreliminaryClaim',
                pathname: '/lmsweb/secure/filepreliminaryclaim.jsp'
            },
            {
                title: 'Create / Modify Final Claim',
                authPrevilege: 'CreateModifyFinalClaim',
                pathname: '/lmsweb/secure/filefinalclaim.jsp'
            }
        ]
    }
]
export const AF_KL_MENU_ITEMS: TMenuItem[] = [
    {
        title: 'Offers',
        pathname: '/',
        authPrevilege: 'OfferMenu',
        subMenus: [
            {
                title: 'Manage AFKL SPOT Rate Offers',
                pathname: '/lmsweb/secure/managespotrate.jsp',
                authPrevilege: 'ManageAFKLSpotRATEOffers'
            },
            {
                title: 'View AFKL SPOT Offer Queue',
                pathname: '/lmsweb/secure/sraqueue.jsp?selCarrier=AF-KL',
                authPrevilege: 'ViewAFKLSPOTofferqueue'
            }
        ]
    },
    {
        title: 'Marketplace',
        pathname: `${ENDPOINT.marketPlace}`,
        authPrevilege: 'Marketplace'
    },
    {
        title: 'Booking',
        pathname: '/',
        authPrevilege: 'Booking',
        subMenus: [
            {
                title: 'Book cargo',
                pathname: 'secure/booking',
                authPrevilege: 'CreateModifyBookingNew',
                badge: 'NEW',
                subTitle: 'Easily create and modify bookings',
                divider: true
            },
            {
                title: 'Search Available Space',
                pathname: '/lmsweb/secure/availability.jsp',
                authPrevilege: 'SearchAvailableSpace'
            },
            {
                title: 'Search Air Waybill Stock',
                pathname: '/lmsweb/secure/awb-stock-status.jsp',
                authPrevilege: 'SearchAirWaybillStock'
            },
            {
                title: 'Create / Modify Booking',
                pathname: '/lmsweb/secure/booking-create.jsp',
                authPrevilege: 'CreateModifyBookingOld'
            },
            {
                title: 'Create Multiple Bookings',
                pathname: '/lmsweb/secure/booking-multiple.jsp',
                authPrevilege: 'CreateMultipleBookings'
            },
            {
                title: 'Create / Modify Booking Templates',
                pathname: '/lmsweb/secure/booking-template.jsp',
                authPrevilege: 'CreateModifyBookingTemplates'
            },
            {
                title: 'Create Spreadsheet Bookings',
                pathname: '/lmsweb/secure/multiCarrierXlsxBooking.jsp',
                authPrevilege: 'CreateSpreadsheetBookings'
            },
            {
                title: 'Create Air Waybill Stock Request',
                pathname: '/lmsweb/secure/awb-stock-request.jsp',
                authPrevilege: 'CreateAirWaybillStockRequest'
            },
            {
                title: 'Create Allotment Request',
                pathname: '/lmsweb/secure/requestallotments.jsp',
                authPrevilege: 'CreateAllotmentRequest'
            },
            {
                title: 'View Allotment Status',
                pathname: '/lmsweb/secure/allocation.jsp',
                authPrevilege: 'ViewAllotmentStatus'
            },
            {
                title: 'View Rate Estimate',
                pathname: '/lmsweb/secure/advancedrateestimate.jsp',
                authPrevilege: 'ViewRateEstimate'
            },
            {
                title: 'View Carrier Schedules',
                pathname: '/lmsweb/flight_schedules.jsp',
                authPrevilege: 'ViewCarrierSchedules'
            },
            {
                title: 'Update Air Waybill Status',
                pathname: '/lmsweb/secure/status_update.jsp',
                authPrevilege: 'UpdateAirWaybillStatus'
            }
        ]
    },
    {
        title: 'e-Freight',
        pathname: '/',
        authPrevilege: 'Efreight',
        subMenus: [
            {
                title: 'Create / Retrive MAWB ',
                pathname: '/lmsweb/secure/retrieve-mawb.jsp',
                authPrevilege: 'CreateRetrieveMAWB'
            },
            {
                title: 'Retrieve e-Docs',
                pathname: '/lmsweb/secure/retrieve-edocs.jsp',
                authPrevilege: 'RetrieveeDocs'
            },
            {
                title: 'Create / Modify PieceID Info',
                pathname: '/lmsweb/secure/piecedetails.jsp',
                authPrevilege: 'CreateModifyPieceIDInfo'
            }
        ]
    },
    {
        title: 'Manage Shipments',
        pathname: '/',
        authPrevilege: 'ManageShipments',
        subMenus: [
            {
                title: 'Track Shipments',
                authPrevilege: 'TrackShipments',
                pathname: '/lmsweb/tracking-awb.jsp'
            },
            {
                title: 'Search Air Waybills',
                authPrevilege: 'SearchAirWaybills',
                pathname: '/lmsweb/secure/tracking-search.jsp'
            },
            {
                title: 'View / Modify Booking',
                authPrevilege: 'ViewModifyBooking',
                pathname: '/lmsweb/secure/booking-modify.jsp'
            },
            {
                title: 'Review Active / Queued Bookings',
                authPrevilege: 'ReviewActiveQueuedBookings',
                pathname: '/lmsweb/secure/booking-summary.jsp'
            },
            {
                title: 'Print Barcode Shipping Label',
                authPrevilege: 'PrintBarcodeShippingLabel',
                pathname: '/lmsweb/secure/booking-print.jsp'
            },
            {
                title: 'Print Shipper Letter Of Instruction',
                authPrevilege: 'PrintShipperLetterOfInstruction',
                pathname: '/lmsweb/secure/booking-printsli.jsp'
            },
            {
                title: 'Make Online Payments',
                authPrevilege: 'MakeOnlinePayments',
                pathname: '/lmsweb/secure/booking-freight.jsp'
            },
            {
                title: 'View Flight Status',
                authPrevilege: 'ViewFlightStatus',
                pathname: '/lmsweb/flight_status.jsp'
            },
            {
                title: 'View Customs Status',
                authPrevilege: 'ViewCustomsStatus',
                pathname: '/lmsweb/customs-status.jsp'
            },
            {
                title: 'View Archived Air Waybill',
                authPrevilege: 'ViewArchivedAirWaybill',
                pathname: '/lmsweb/secure/archivedshipments.jsp'
            }
        ]
    },
    {
        title: 'e-Claims',
        pathname: '/',
        authPrevilege: 'eClaims',
        subMenus: [
            {
                title: 'File Damage Report',
                authPrevilege: 'FileDamageReport',
                pathname: '/lmsweb/secure/damagereport.jsp'
            },
            {
                title: 'View Damage Report Status',
                authPrevilege: 'ViewDamageReportStatus',
                pathname: '/lmsweb/secure/damagereportstatus.jsp'
            },
            {
                title: 'Create / Modify Preliminary Claim',
                authPrevilege: 'CreateModifyPreliminaryClaim',
                pathname: '/lmsweb/secure/filepreliminaryclaim.jsp'
            },
            {
                title: 'Create / Modify Final Claim',
                authPrevilege: 'CreateModifyFinalClaim',
                pathname: '/lmsweb/secure/filefinalclaim.jsp'
            }
        ]
    }
]
export const AI_MENU_ITEMS: TMenuItem[] = [
    {
        title: 'Offers',
        pathname: '/',
        authPrevilege: 'OfferMenu',
        subMenus: [
            {
                title: 'Manage AI SPOT Rate Offers',
                pathname: '/lmsweb/secure/managespotrate.jsp',
                authPrevilege: 'ManageAISpotRATEOffers'
            },
            {
                title: 'View AI SPOT Offer Queue',
                pathname: '/lmsweb/secure/sraqueue.jsp?selCarrier=AI',
                authPrevilege: 'ViewAISPOTofferqueue'
            }
        ]
    },
    {
        title: 'Marketplace',
        pathname: `${ENDPOINT.marketPlace}`,
        authPrevilege: 'Marketplace'
    },
    {
        title: 'Booking',
        pathname: '/',
        authPrevilege: 'Booking',
        subMenus: [
            {
                title: 'Book cargo',
                pathname: 'secure/booking',
                authPrevilege: 'CreateModifyBookingNew',
                badge: 'NEW',
                subTitle: 'Easily create and modify bookings',
                divider: true
            },
            {
                title: 'Search Availability and Price',
                pathname: '/lmsweb/secure/advancedrate.jsp',
                authPrevilege: 'SearchAvailabilityAndPrice'
            },
            {
                title: 'Search Available Space',
                pathname: '/lmsweb/secure/availability.jsp',
                authPrevilege: 'SearchAvailableSpace'
            },
            {
                title: 'Search Air Waybill Stock',
                pathname: '/lmsweb/secure/awb-stock-status.jsp',
                authPrevilege: 'SearchAirWaybillStock'
            },
            {
                title: 'Create / Modify Booking',
                pathname: '/lmsweb/secure/booking-create.jsp',
                authPrevilege: 'CreateModifyBookingOld'
            },
            {
                title: 'Create Multiple Bookings',
                pathname: '/lmsweb/secure/booking-multiple.jsp',
                authPrevilege: 'CreateMultipleBookings'
            },
            {
                title: 'Create / Modify Booking Templates',
                pathname: '/lmsweb/secure/booking-template.jsp',
                authPrevilege: 'CreateModifyBookingTemplates'
            },
            {
                title: 'Create Spreadsheet Bookings',
                pathname: '/lmsweb/secure/multiCarrierXlsxBooking.jsp',
                authPrevilege: 'CreateSpreadsheetBookings'
            },
            {
                title: 'Create Air Waybill Stock Request',
                pathname: '/lmsweb/secure/awb-stock-request.jsp',
                authPrevilege: 'CreateAirWaybillStockRequest'
            },
            {
                title: 'Create Allotment Request',
                pathname: '/lmsweb/secure/requestallotments.jsp',
                authPrevilege: 'CreateAllotmentRequest'
            },
            {
                title: 'View Allotment Status',
                pathname: '/lmsweb/secure/allocation.jsp',
                authPrevilege: 'ViewAllotmentStatus'
            },
            {
                title: 'View Rate Estimate',
                pathname: '/lmsweb/secure/advancedrateestimate.jsp',
                authPrevilege: 'ViewRateEstimate'
            },
            {
                title: 'View Carrier Schedules',
                pathname: '/lmsweb/flight_schedules.jsp',
                authPrevilege: 'ViewCarrierSchedules'
            },
            {
                title: 'Update Air Waybill Status',
                pathname: '/lmsweb/secure/status_update.jsp',
                authPrevilege: 'UpdateAirWaybillStatus'
            }
        ]
    },
    {
        title: 'e-Freight',
        pathname: '/',
        authPrevilege: 'Efreight',
        subMenus: [
            {
                title: 'Create / Retrieve MAWB',
                pathname: '/lmsweb/secure/retrieve-mawb.jsp',
                authPrevilege: 'CreateRetrieveMAWB'
            },
            {
                title: 'Retrieve e-Docs',
                pathname: '/lmsweb/secure/retrieve-edocs.jsp',
                authPrevilege: 'RetrieveeDocs'
            },
            {
                title: 'Create / Modify HAWB',
                pathname: '/lmsweb/secure/customs.jsp',
                authPrevilege: 'CreateModifyHAWB'
            },
            {
                title: 'Create / Modify HAWB Templates',
                pathname: '/lmsweb/secure/hawb-template.jsp?btnHawbList=Y&optUserId=BRANCH',
                authPrevilege: 'CreateModifyHAWBTemplates'
            },
            {
                title: 'Create / Modify PieceID Info',
                pathname: '/lmsweb/secure/piecedetails.jsp',
                authPrevilege: 'CreateModifyPieceIDInfo'
            }
        ]
    },
    {
        title: 'Manage Shipments',
        pathname: '/',
        authPrevilege: 'ManageShipments',
        subMenus: [
            {
                title: 'Track Shipments',
                authPrevilege: 'TrackShipments',
                pathname: '/lmsweb/tracking-awb.jsp'
            },
            {
                title: 'Search Air Waybills',
                authPrevilege: 'SearchAirWaybills',
                pathname: '/lmsweb/secure/tracking-search.jsp'
            },
            {
                title: 'View / Modify Booking',
                authPrevilege: 'ViewModifyBooking',
                pathname: '/lmsweb/secure/booking-modify.jsp'
            },
            {
                title: 'Review Active / Queued Bookings',
                authPrevilege: 'ReviewActiveQueuedBookings',
                pathname: '/lmsweb/secure/booking-summary.jsp'
            },
            {
                title: 'Print Barcode Shipping Label',
                authPrevilege: 'PrintBarcodeShippingLabel',
                pathname: '/lmsweb/secure/booking-print.jsp'
            },
            {
                title: 'Print Shipper Letter Of Instruction',
                authPrevilege: 'PrintShipperLetterOfInstruction',
                pathname: '/lmsweb/secure/booking-printsli.jsp'
            },
            {
                title: 'Make Online Payments',
                authPrevilege: 'MakeOnlinePayments',
                pathname: '/lmsweb/secure/booking-freight.jsp'
            },
            {
                title: 'View Flight Status',
                authPrevilege: 'ViewFlightStatus',
                pathname: '/lmsweb/flight_status.jsp'
            },
            {
                title: 'View Customs Status',
                authPrevilege: 'ViewCustomsStatus',
                pathname: '/lmsweb/customs-status.jsp'
            },
            {
                title: 'View Archived Air Waybill',
                authPrevilege: 'ViewArchivedAirWaybill',
                pathname: '/lmsweb/secure/archivedshipments.jsp'
            },
            {
                title: 'Shipment Release Declaration',
                authPrevilege: 'ShipmentReleaseDeclaration',
                pathname: '/lmsweb/secure/declaration.jsp'
            }
        ]
    },
    {
        title: 'e-Claims',
        pathname: '/',
        authPrevilege: 'eClaims',
        subMenus: [
            {
                title: 'File Damage Report',
                authPrevilege: 'FileDamageReport',
                pathname: '/lmsweb/secure/damagereport.jsp'
            },
            {
                title: 'View Damage Report Status',
                authPrevilege: 'ViewDamageReportStatus',
                pathname: '/lmsweb/secure/damagereportstatus.jsp'
            },
            {
                title: 'Create / Modify Preliminary Claim',
                authPrevilege: 'CreateModifyPreliminaryClaim',
                pathname: '/lmsweb/secure/filepreliminaryclaim.jsp'
            },
            {
                title: 'Create / Modify Final Claim',
                authPrevilege: 'CreateModifyFinalClaim',
                pathname: '/lmsweb/secure/filefinalclaim.jsp'
            }
        ]
    }
]
export const MH_MENU_ITEMS: TMenuItem[] = [
    {
        title: 'Offers',
        pathname: '/',
        authPrevilege: 'OfferMenu',
        subMenus: [
            {
                title: 'Manage MH SPOT Rate Offers',
                pathname: '/lmsweb/secure/managespotrate.jsp',
                authPrevilege: 'ManageMHSpotRATEOffers'
            },
            {
                title: 'View MH SPOT Offer Queue',
                pathname: '/lmsweb/secure/sraqueue.jsp?selCarrier=MH',
                authPrevilege: 'ViewMHSPOTofferqueue'
            }
        ]
    },
    {
        title: 'Marketplace',
        pathname: `${ENDPOINT.marketPlace}`,
        authPrevilege: 'Marketplace'
    },
    {
        title: 'Booking',
        pathname: '/',
        authPrevilege: 'Booking',
        subMenus: [
            {
                title: 'Book cargo',
                pathname: 'secure/booking',
                authPrevilege: 'CreateModifyBookingNew',
                badge: 'NEW',
                subTitle: 'Easily create and modify bookings',
                divider: true
            },
            {
                title: 'Search Availability and Price',
                pathname: '/lmsweb/secure/advancedrate.jsp',
                authPrevilege: 'SearchAvailabilityAndPrice'
            },
            {
                title: 'Search Available Space',
                pathname: '/lmsweb/secure/availability.jsp',
                authPrevilege: 'SearchAvailableSpace'
            },
            {
                title: 'Search Air Waybill Stock',
                pathname: '/lmsweb/secure/awb-stock-status.jsp',
                authPrevilege: 'SearchAirWaybillStock'
            },
            {
                title: 'Create / Modify Booking',
                pathname: '/lmsweb/secure/booking-create.jsp',
                authPrevilege: 'CreateModifyBookingOld'
            },
            {
                title: 'Create Multiple Bookings',
                pathname: '/lmsweb/secure/booking-multiple.jsp',
                authPrevilege: 'CreateMultipleBookings'
            },
            {
                title: 'Create / Modify Booking Templates',
                pathname: '/lmsweb/secure/booking-template.jsp',
                authPrevilege: 'CreateModifyBookingTemplates'
            },
            {
                title: 'Create Spreadsheet Bookings',
                pathname: '/lmsweb/secure/multiCarrierXlsxBooking.jsp',
                authPrevilege: 'CreateSpreadsheetBookings'
            },
            {
                title: 'Create Air Waybill Stock Request',
                pathname: '/lmsweb/secure/awb-stock-request.jsp',
                authPrevilege: 'CreateAirWaybillStockRequest'
            },
            {
                title: 'Create Allotment Request',
                pathname: '/lmsweb/secure/requestallotments.jsp',
                authPrevilege: 'CreateAllotmentRequest'
            },
            {
                title: 'View Allotment Status',
                pathname: '/lmsweb/secure/allocation.jsp',
                authPrevilege: 'ViewAllotmentStatus'
            },
            {
                title: 'View Rate Estimate',
                pathname: '/lmsweb/secure/advancedrateestimate.jsp',
                authPrevilege: 'ViewRateEstimate'
            },
            {
                title: 'View Carrier Schedules',
                pathname: '/lmsweb/flight_schedules.jsp',
                authPrevilege: 'ViewCarrierSchedules'
            },
            {
                title: 'Update Air Waybill Status',
                pathname: '/lmsweb/secure/status_update.jsp',
                authPrevilege: 'UpdateAirWaybillStatus'
            }
        ]
    },
    {
        title: 'e-Freight',
        pathname: '/',
        authPrevilege: 'Efreight',
        subMenus: [
            {
                title: 'Create / Retrieve MAWB',
                pathname: '/lmsweb/secure/retrieve-mawb.jsp',
                authPrevilege: 'CreateRetrieveMAWB'
            },
            {
                title: 'Retrieve e-Docs',
                pathname: '/lmsweb/secure/retrieve-edocs.jsp',
                authPrevilege: 'RetrieveeDocs'
            },
            {
                title: 'Create / Modify HAWB',
                pathname: '/lmsweb/secure/customs.jsp',
                authPrevilege: 'CreateModifyHAWB'
            },
            {
                title: 'Create / Modify HAWB Templates',
                pathname: '/lmsweb/secure/hawb-template.jsp?btnHawbList=Y&optUserId=BRANCH',
                authPrevilege: 'CreateModifyHAWBTemplates'
            },
            {
                title: 'Create / Modify PieceID Info',
                pathname: '/lmsweb/secure/piecedetails.jsp',
                authPrevilege: 'CreateModifyPieceIDInfo'
            }
        ]
    },
    {
        title: 'Manage Shipments',
        pathname: '/',
        authPrevilege: 'ManageShipments',
        subMenus: [
            {
                title: 'Track Shipments',
                authPrevilege: 'TrackShipments',
                pathname: '/lmsweb/tracking-awb.jsp'
            },
            {
                title: 'Search Air Waybills',
                authPrevilege: 'SearchAirWaybills',
                pathname: '/lmsweb/secure/tracking-search.jsp'
            },
            {
                title: 'View / Modify Booking',
                authPrevilege: 'ViewModifyBooking',
                pathname: '/lmsweb/secure/booking-modify.jsp'
            },
            {
                title: 'Review Active / Queued Bookings',
                authPrevilege: 'ReviewActiveQueuedBookings',
                pathname: '/lmsweb/secure/booking-summary.jsp'
            },
            {
                title: 'Print Barcode Shipping Label',
                authPrevilege: 'PrintBarcodeShippingLabel',
                pathname: '/lmsweb/secure/booking-print.jsp'
            },
            {
                title: 'Print Shipper Letter Of Instruction',
                authPrevilege: 'PrintShipperLetterOfInstruction',
                pathname: '/lmsweb/secure/booking-printsli.jsp'
            },
            {
                title: 'Make Online Payments',
                authPrevilege: 'MakeOnlinePayments',
                pathname: '/lmsweb/secure/booking-freight.jsp'
            },
            {
                title: 'View Flight Status',
                authPrevilege: 'ViewFlightStatus',
                pathname: '/lmsweb/flight_status.jsp'
            },
            {
                title: 'View Customs Status',
                authPrevilege: 'ViewCustomsStatus',
                pathname: '/lmsweb/customs-status.jsp'
            },
            {
                title: 'View Archived Air Waybill',
                authPrevilege: 'ViewArchivedAirWaybill',
                pathname: '/lmsweb/secure/archivedshipments.jsp'
            },
            {
                title: 'Shipment Release Declaration',
                authPrevilege: 'ShipmentReleaseDeclaration',
                pathname: '/lmsweb/secure/declaration.jsp'
            }
        ]
    },
    {
        title: 'e-Claims',
        pathname: '/',
        authPrevilege: 'eClaims',
        subMenus: [
            {
                title: 'File Damage Report',
                authPrevilege: 'FileDamageReport',
                pathname: '/lmsweb/secure/damagereport.jsp'
            },
            {
                title: 'View Damage Report Status',
                authPrevilege: 'ViewDamageReportStatus',
                pathname: '/lmsweb/secure/damagereportstatus.jsp'
            },
            {
                title: 'Create / Modify Preliminary Claim',
                authPrevilege: 'CreateModifyPreliminaryClaim',
                pathname: '/lmsweb/secure/filepreliminaryclaim.jsp'
            },
            {
                title: 'Create / Modify Final Claim',
                authPrevilege: 'CreateModifyFinalClaim',
                pathname: '/lmsweb/secure/filefinalclaim.jsp'
            }
        ]
    }
]
export const NZ_MENU_ITEMS: TMenuItem[] = [
    {
        title: 'Offers',
        pathname: '/',
        authPrevilege: 'OfferMenu',
        subMenus: [
            {
                title: 'Manage NZ SPOT Rate Offers',
                pathname: '/lmsweb/secure/managespotrate.jsp',
                authPrevilege: 'ManageNZSpotRATEOffers'
            },
            {
                title: 'View NZ SPOT Offer Queue',
                pathname: '/lmsweb/secure/sraqueue.jsp?selCarrier=NZ',
                authPrevilege: 'ViewNZSPOTofferqueue'
            }
        ]
    },
    {
        title: 'Marketplace',
        pathname: `${ENDPOINT.marketPlace}`,
        authPrevilege: 'Marketplace'
    },
    {
        title: 'Booking',
        pathname: '/',
        authPrevilege: 'Booking',
        subMenus: [
            {
                title: 'Book cargo',
                pathname: 'secure/booking',
                authPrevilege: 'CreateModifyBookingNew',
                badge: 'NEW',
                subTitle: 'Easily create and modify bookings',
                divider: true
            },
            {
                title: 'Search Available Space',
                pathname: '/lmsweb/secure/availability.jsp',
                authPrevilege: 'SearchAvailableSpace'
            },
            {
                title: 'Search Air Waybill Stock',
                pathname: '/lmsweb/secure/awb-stock-status.jsp',
                authPrevilege: 'SearchAirWaybillStock'
            },
            {
                title: 'Create / Modify Booking',
                pathname: '/lmsweb/secure/booking-create.jsp',
                authPrevilege: 'CreateModifyBookingOld'
            },
            {
                title: 'Create Multiple Bookings',
                pathname: '/lmsweb/secure/booking-multiple.jsp',
                authPrevilege: 'CreateMultipleBookings'
            },
            {
                title: 'Create / Modify Booking Templates',
                pathname: '/lmsweb/secure/booking-template.jsp',
                authPrevilege: 'CreateModifyBookingTemplates'
            },
            {
                title: 'Create Spreadsheet Bookings',
                pathname: '/lmsweb/secure/multiCarrierXlsxBooking.jsp',
                authPrevilege: 'CreateSpreadsheetBookings'
            },
            {
                title: 'Create Air Waybill Stock Request',
                pathname: '/lmsweb/secure/awb-stock-request.jsp',
                authPrevilege: 'CreateAirWaybillStockRequest'
            },
            {
                title: 'Create Allotment Request',
                pathname: '/lmsweb/secure/requestallotments.jsp',
                authPrevilege: 'CreateAllotmentRequest'
            },
            {
                title: 'View Allotment Status',
                pathname: '/lmsweb/secure/allocation.jsp',
                authPrevilege: 'ViewAllotmentStatus'
            },
            {
                title: 'View Rate Estimate',
                pathname: '/lmsweb/secure/advancedrateestimate.jsp',
                authPrevilege: 'ViewRateEstimate'
            },
            {
                title: 'View Carrier Schedules',
                pathname: '/lmsweb/flight_schedules.jsp',
                authPrevilege: 'ViewCarrierSchedules'
            },
            {
                title: 'Update Air Waybill Status',
                pathname: '/lmsweb/secure/status_update.jsp',
                authPrevilege: 'UpdateAirWaybillStatus'
            }
        ]
    },
    {
        title: 'e-Freight',
        pathname: '/',
        authPrevilege: 'Efreight',
        subMenus: [
            {
                title: 'Create / Retrieve MAWB',
                pathname: '/lmsweb/secure/retrieve-mawb.jsp',
                authPrevilege: 'CreateRetrieveMAWB'
            },
            {
                title: 'Retrieve e-Docs',
                pathname: '/lmsweb/secure/retrieve-edocs.jsp',
                authPrevilege: 'RetrieveeDocs'
            },
            {
                title: 'Create / Modify HAWB',
                pathname: '/lmsweb/secure/customs.jsp',
                authPrevilege: 'CreateModifyHAWB'
            },
            {
                title: 'Create / Modify HAWB Templates',
                pathname: '/lmsweb/secure/hawb-template.jsp?btnHawbList=Y&optUserId=BRANCH',
                authPrevilege: 'CreateModifyHAWBTemplates'
            },
            {
                title: 'Create / Modify PieceID Info',
                pathname: '/lmsweb/secure/piecedetails.jsp',
                authPrevilege: 'CreateModifyPieceIDInfo'
            }
        ]
    },
    {
        title: 'Manage Shipments',
        pathname: '/',
        authPrevilege: 'ManageShipments',
        subMenus: [
            {
                title: 'Track Shipments',
                authPrevilege: 'TrackShipments',
                pathname: '/lmsweb/tracking-awb.jsp'
            },
            {
                title: 'Search Air Waybills',
                authPrevilege: 'SearchAirWaybills',
                pathname: '/lmsweb/secure/tracking-search.jsp'
            },
            {
                title: 'View / Modify Booking',
                authPrevilege: 'ViewModifyBooking',
                pathname: '/lmsweb/secure/booking-modify.jsp'
            },
            {
                title: 'Review Active / Queued Bookings',
                authPrevilege: 'ReviewActiveQueuedBookings',
                pathname: '/lmsweb/secure/booking-summary.jsp'
            },
            {
                title: 'Print Barcode Shipping Label',
                authPrevilege: 'PrintBarcodeShippingLabel',
                pathname: '/lmsweb/secure/booking-print.jsp'
            },
            {
                title: 'Print Shipper Letter Of Instruction',
                authPrevilege: 'PrintShipperLetterOfInstruction',
                pathname: '/lmsweb/secure/booking-printsli.jsp'
            },
            {
                title: 'Make Online Payments',
                authPrevilege: 'MakeOnlinePayments',
                pathname: '/lmsweb/secure/booking-freight.jsp'
            },
            {
                title: 'View Flight Status',
                authPrevilege: 'ViewFlightStatus',
                pathname: '/lmsweb/flight_status.jsp'
            },
            {
                title: 'View Customs Status',
                authPrevilege: 'ViewCustomsStatus',
                pathname: '/lmsweb/customs-status.jsp'
            },
            {
                title: 'View Archived Air Waybill',
                authPrevilege: 'ViewArchivedAirWaybill',
                pathname: '/lmsweb/secure/archivedshipments.jsp'
            },
            {
                title: 'Shipment Release Declaration',
                authPrevilege: 'ShipmentReleaseDeclaration',
                pathname: '/lmsweb/secure/declaration.jsp'
            }
        ]
    },
    {
        title: 'e-Claims',
        pathname: '/',
        authPrevilege: 'eClaims',
        subMenus: [
            {
                title: 'File Damage Report',
                authPrevilege: 'FileDamageReport',
                pathname: '/lmsweb/secure/damagereport.jsp'
            },
            {
                title: 'View Damage Report Status',
                authPrevilege: 'ViewDamageReportStatus',
                pathname: '/lmsweb/secure/damagereportstatus.jsp'
            },
            {
                title: 'Create / Modify Preliminary Claim',
                authPrevilege: 'CreateModifyPreliminaryClaim',
                pathname: '/lmsweb/secure/filepreliminaryclaim.jsp'
            },
            {
                title: 'Create / Modify Final Claim',
                authPrevilege: 'CreateModifyFinalClaim',
                pathname: '/lmsweb/secure/filefinalclaim.jsp'
            }
        ]
    }
]
export const SK_MENU_ITEMS: TMenuItem[] = [
    {
        title: 'Offers',
        pathname: '/',
        authPrevilege: 'OfferMenu',
        subMenus: [
            {
                title: 'Manage SK SPOT Rate Offers',
                pathname: '/lmsweb/secure/managespotrate.jsp',
                authPrevilege: 'ManageSKSpotRATEOffers'
            },
            {
                title: 'View SK SPOT Offer Queue',
                pathname: '/lmsweb/secure/sraqueue.jsp?selCarrier=SK',
                authPrevilege: 'ViewSKSPOTofferqueue'
            }
        ]
    },
    {
        title: 'Marketplace',
        pathname: `${ENDPOINT.marketPlace}`,
        authPrevilege: 'Marketplace'
    },
    {
        title: 'Booking',
        pathname: '/',
        authPrevilege: 'Booking',
        subMenus: [
            {
                title: 'Book cargo',
                pathname: 'secure/booking',
                authPrevilege: 'CreateModifyBookingNew',
                badge: 'NEW',
                subTitle: 'Easily create and modify bookings',
                divider: true
            },
            {
                title: 'Search Availability and Price',
                pathname: '/lmsweb/secure/advancedrate.jsp',
                authPrevilege: 'SearchAvailabilityAndPrice'
            },
            {
                title: 'Search Available Space',
                pathname: '/lmsweb/secure/availability.jsp',
                authPrevilege: 'SearchAvailableSpace'
            },
            {
                title: 'Search Air Waybill Stock',
                pathname: '/lmsweb/secure/awb-stock-status.jsp',
                authPrevilege: 'SearchAirWaybillStock'
            },
            {
                title: 'Create / Modify Booking',
                pathname: '/lmsweb/secure/booking-create.jsp',
                authPrevilege: 'CreateModifyBookingOld'
            },
            {
                title: 'Create Multiple Bookings',
                pathname: '/lmsweb/secure/booking-multiple.jsp',
                authPrevilege: 'CreateMultipleBookings'
            },
            {
                title: 'Create / Modify Booking Templates',
                pathname: '/lmsweb/secure/booking-template.jsp',
                authPrevilege: 'CreateModifyBookingTemplates'
            },
            {
                title: 'Create Spreadsheet Bookings',
                pathname: '/lmsweb/secure/multiCarrierXlsxBooking.jsp',
                authPrevilege: 'CreateSpreadsheetBookings'
            },
            {
                title: 'Create Air Waybill Stock Request',
                pathname: '/lmsweb/secure/awb-stock-request.jsp',
                authPrevilege: 'CreateAirWaybillStockRequest'
            },
            {
                title: 'Create Allotment Request',
                pathname: '/lmsweb/secure/requestallotments.jsp',
                authPrevilege: 'CreateAllotmentRequest'
            },
            {
                title: 'View Allotment Status',
                pathname: '/lmsweb/secure/allocation.jsp',
                authPrevilege: 'ViewAllotmentStatus'
            },
            {
                title: 'View Rate Estimate',
                pathname: '/lmsweb/secure/advancedrateestimate.jsp',
                authPrevilege: 'ViewRateEstimate'
            },
            {
                title: 'View Carrier Schedules',
                pathname: '/lmsweb/flight_schedules.jsp',
                authPrevilege: 'ViewCarrierSchedules'
            },
            {
                title: 'Update Air Waybill Status',
                pathname: '/lmsweb/secure/status_update.jsp',
                authPrevilege: 'UpdateAirWaybillStatus'
            }
        ]
    },
    {
        title: 'e-Freight',
        pathname: '/',
        authPrevilege: 'Efreight',
        subMenus: [
            {
                title: 'Create / Retrieve MAWB',
                pathname: '/lmsweb/secure/retrieve-mawb.jsp',
                authPrevilege: 'CreateRetrieveMAWB'
            },
            {
                title: 'Retrieve e-Docs',
                pathname: '/lmsweb/secure/retrieve-edocs.jsp',
                authPrevilege: 'RetrieveeDocs'
            },
            {
                title: 'Create / Modify HAWB',
                pathname: '/lmsweb/secure/customs.jsp',
                authPrevilege: 'CreateModifyHAWB'
            },
            {
                title: 'Create / Modify HAWB Templates',
                pathname: '/lmsweb/secure/hawb-template.jsp?btnHawbList=Y&optUserId=BRANCH',
                authPrevilege: 'CreateModifyHAWBTemplates'
            },
            {
                title: 'Create / Modify PieceID Info',
                pathname: '/lmsweb/secure/piecedetails.jsp',
                authPrevilege: 'CreateModifyPieceIDInfo'
            }
        ]
    },
    {
        title: 'Manage Shipments',
        pathname: '/',
        authPrevilege: 'ManageShipments',
        subMenus: [
            {
                title: 'Track Shipments',
                authPrevilege: 'TrackShipments',
                pathname: '/lmsweb/tracking-awb.jsp'
            },
            {
                title: 'Search Air Waybills',
                authPrevilege: 'SearchAirWaybills',
                pathname: '/lmsweb/secure/tracking-search.jsp'
            },
            {
                title: 'View / Modify Booking',
                authPrevilege: 'ViewModifyBooking',
                pathname: '/lmsweb/secure/booking-modify.jsp'
            },
            {
                title: 'Review Active / Queued Bookings',
                authPrevilege: 'ReviewActiveQueuedBookings',
                pathname: '/lmsweb/secure/booking-summary.jsp'
            },
            {
                title: 'Print Barcode Shipping Label',
                authPrevilege: 'PrintBarcodeShippingLabel',
                pathname: '/lmsweb/secure/booking-print.jsp'
            },
            {
                title: 'Print Shipper Letter Of Instruction',
                authPrevilege: 'PrintShipperLetterOfInstruction',
                pathname: '/lmsweb/secure/booking-printsli.jsp'
            },
            {
                title: 'Make Online Payments',
                authPrevilege: 'MakeOnlinePayments',
                pathname: '/lmsweb/secure/booking-freight.jsp'
            },
            {
                title: 'View Flight Status',
                authPrevilege: 'ViewFlightStatus',
                pathname: '/lmsweb/flight_status.jsp'
            },
            {
                title: 'View Customs Status',
                authPrevilege: 'ViewCustomsStatus',
                pathname: '/lmsweb/customs-status.jsp'
            },
            {
                title: 'View Archived Air Waybill',
                authPrevilege: 'ViewArchivedAirWaybill',
                pathname: '/lmsweb/secure/archivedshipments.jsp'
            },
            {
                title: 'Shipment Release Declaration',
                authPrevilege: 'ShipmentReleaseDeclaration',
                pathname: '/lmsweb/secure/declaration.jsp'
            }
        ]
    },
    {
        title: 'e-Claims',
        pathname: '/',
        authPrevilege: 'eClaims',
        subMenus: [
            {
                title: 'File Damage Report',
                authPrevilege: 'FileDamageReport',
                pathname: '/lmsweb/secure/damagereport.jsp'
            },
            {
                title: 'View Damage Report Status',
                authPrevilege: 'ViewDamageReportStatus',
                pathname: '/lmsweb/secure/damagereportstatus.jsp'
            },
            {
                title: 'Create / Modify Preliminary Claim',
                authPrevilege: 'CreateModifyPreliminaryClaim',
                pathname: '/lmsweb/secure/filepreliminaryclaim.jsp'
            },
            {
                title: 'Create / Modify Final Claim',
                authPrevilege: 'CreateModifyFinalClaim',
                pathname: '/lmsweb/secure/filefinalclaim.jsp'
            }
        ]
    }
]
export const UA_MENU_ITEMS: TMenuItem[] = [
    {
        title: 'Offers',
        pathname: '/',
        authPrevilege: 'OfferMenu',
        subMenus: [
            {
                title: 'Manage UA SPOT Rate Offers',
                pathname: '/lmsweb/secure/managespotrate.jsp',
                authPrevilege: 'ManageUASpotRATEOffers'
            },
            {
                title: 'View UA SPOT Offer Queue',
                pathname: '/lmsweb/secure/sraqueue.jsp?selCarrier=UA',
                authPrevilege: 'ViewUASPOTofferqueue'
            }
        ]
    },
    {
        title: 'Marketplace',
        pathname: `${ENDPOINT.marketPlace}`,
        authPrevilege: 'Marketplace'
    },
    {
        title: 'Booking',
        pathname: '/',
        authPrevilege: 'Booking',
        subMenus: [
            {
                title: 'Book cargo',
                pathname: 'secure/booking',
                authPrevilege: 'CreateModifyBookingNew',
                badge: 'NEW',
                subTitle: 'Easily create and modify bookings',
                divider: true
            },
            {
                title: 'Search Available Space',
                pathname: '/lmsweb/secure/availability.jsp',
                authPrevilege: 'SearchAvailableSpace'
            },
            {
                title: 'Search Air Waybill Stock',
                pathname: '/lmsweb/secure/awb-stock-status.jsp',
                authPrevilege: 'SearchAirWaybillStock'
            },
            {
                title: 'Create / Modify Booking',
                pathname: '/lmsweb/secure/booking-create.jsp',
                authPrevilege: 'CreateModifyBookingOld'
            },
            {
                title: 'Create Multiple Bookings',
                pathname: '/lmsweb/secure/booking-multiple.jsp',
                authPrevilege: 'CreateMultipleBookings'
            },
            {
                title: 'Create / Modify Booking Templates',
                pathname: '/lmsweb/secure/booking-template.jsp',
                authPrevilege: 'CreateModifyBookingTemplates'
            },
            {
                title: 'Create Spreadsheet Bookings',
                pathname: '/lmsweb/secure/multiCarrierXlsxBooking.jsp',
                authPrevilege: 'CreateSpreadsheetBookings'
            },
            {
                title: 'Create Air Waybill Stock Request',
                pathname: '/lmsweb/secure/awb-stock-request.jsp',
                authPrevilege: 'CreateAirWaybillStockRequest'
            },
            {
                title: 'Create Allotment Request',
                pathname: '/lmsweb/secure/requestallotments.jsp',
                authPrevilege: 'CreateAllotmentRequest'
            },
            {
                title: 'View Allotment Status',
                pathname: '/lmsweb/secure/allocation.jsp',
                authPrevilege: 'ViewAllotmentStatus'
            },
            {
                title: 'View Rate Estimate',
                pathname: '/lmsweb/secure/advancedrateestimate.jsp',
                authPrevilege: 'ViewRateEstimate'
            },
            {
                title: 'View Carrier Schedules',
                pathname: '/lmsweb/flight_schedules.jsp',
                authPrevilege: 'ViewCarrierSchedules'
            },
            {
                title: 'Update Air Waybill Status',
                pathname: '/lmsweb/secure/status_update.jsp',
                authPrevilege: 'UpdateAirWaybillStatus'
            }
        ]
    },
    {
        title: 'e-Freight',
        pathname: '/',
        authPrevilege: 'Efreight',
        subMenus: [
            {
                title: 'Create / Retrieve MAWB',
                pathname: '/lmsweb/secure/retrieve-mawb.jsp',
                authPrevilege: 'CreateRetrieveMAWB'
            },
            {
                title: 'Retrieve e-Docs',
                pathname: '/lmsweb/secure/retrieve-edocs.jsp',
                authPrevilege: 'RetrieveeDocs'
            },
            {
                title: 'Create / Modify HAWB',
                pathname: '/lmsweb/secure/customs.jsp',
                authPrevilege: 'CreateModifyHAWB'
            },
            {
                title: 'Create / Modify HAWB Templates',
                pathname: '/lmsweb/secure/hawb-template.jsp?btnHawbList=Y&optUserId=BRANCH',
                authPrevilege: 'CreateModifyHAWBTemplates'
            },
            {
                title: 'Create / Modify PieceID Info',
                pathname: '/lmsweb/secure/piecedetails.jsp',
                authPrevilege: 'CreateModifyPieceIDInfo'
            }
        ]
    },
    {
        title: 'Manage Shipments',
        pathname: '/',
        authPrevilege: 'ManageShipments',
        subMenus: [
            {
                title: 'Track Shipments',
                authPrevilege: 'TrackShipments',
                pathname: '/lmsweb/tracking-awb.jsp'
            },
            {
                title: 'Search Air Waybills',
                authPrevilege: 'SearchAirWaybills',
                pathname: '/lmsweb/secure/tracking-search.jsp'
            },
            {
                title: 'View / Modify Booking',
                authPrevilege: 'ViewModifyBooking',
                pathname: '/lmsweb/secure/booking-modify.jsp'
            },
            {
                title: 'Review Active / Queued Bookings',
                authPrevilege: 'ReviewActiveQueuedBookings',
                pathname: '/lmsweb/secure/booking-summary.jsp'
            },
            {
                title: 'Print Barcode Shipping Label',
                authPrevilege: 'PrintBarcodeShippingLabel',
                pathname: '/lmsweb/secure/booking-print.jsp'
            },
            {
                title: 'Print Shipper Letter Of Instruction',
                authPrevilege: 'PrintShipperLetterOfInstruction',
                pathname: '/lmsweb/secure/booking-printsli.jsp'
            },
            {
                title: 'Make Online Payments',
                authPrevilege: 'MakeOnlinePayments',
                pathname: '/lmsweb/secure/booking-freight.jsp'
            },
            {
                title: 'View Flight Status',
                authPrevilege: 'ViewFlightStatus',
                pathname: '/lmsweb/flight_status.jsp'
            },
            {
                title: 'View Customs Status',
                authPrevilege: 'ViewCustomsStatus',
                pathname: '/lmsweb/customs-status.jsp'
            },
            {
                title: 'View Archived Air Waybill',
                authPrevilege: 'ViewArchivedAirWaybill',
                pathname: '/lmsweb/secure/archivedshipments.jsp'
            }
        ]
    },
    {
        title: 'e-Claims',
        pathname: '/',
        authPrevilege: 'eClaims',
        subMenus: [
            {
                title: 'File Damage Report',
                authPrevilege: 'FileDamageReport',
                pathname: '/lmsweb/secure/damagereport.jsp'
            },
            {
                title: 'View Damage Report Status',
                authPrevilege: 'ViewDamageReportStatus',
                pathname: '/lmsweb/secure/damagereportstatus.jsp'
            },
            {
                title: 'Create / Modify Preliminary Claim',
                authPrevilege: 'CreateModifyPreliminaryClaim',
                pathname: '/lmsweb/secure/filepreliminaryclaim.jsp'
            },
            {
                title: 'Create / Modify Final Claim',
                authPrevilege: 'CreateModifyFinalClaim',
                pathname: '/lmsweb/secure/filefinalclaim.jsp'
            }
        ]
    }
]
export const UW_MENU_ITEMS: TMenuItem[] = [
    {
        title: 'Offers',
        pathname: '/',
        authPrevilege: 'OfferMenu',
        subMenus: [
            {
                title: 'Manage UW SPOT Rate Offers',
                pathname: '/lmsweb/secure/managespotrate.jsp',
                authPrevilege: 'ManageUWSpotRATEOffers'
            },
            {
                title: 'View UW SPOT Offer Queue',
                pathname: '/lmsweb/secure/sraqueue.jsp?selCarrier=UW',
                authPrevilege: 'ViewUWSPOTofferqueue'
            }
        ]
    },
    {
        title: 'Marketplace',
        pathname: `${ENDPOINT.marketPlace}`,
        authPrevilege: 'Marketplace'
    },
    {
        title: 'Booking',
        pathname: '/',
        authPrevilege: 'Booking',
        subMenus: [
            {
                title: 'Book cargo',
                pathname: 'secure/booking',
                authPrevilege: 'CreateModifyBookingNew',
                badge: 'NEW',
                subTitle: 'Easily create and modify bookings',
                divider: true
            },
            {
                title: 'Search Availability and Price',
                pathname: '/lmsweb/secure/advancedrate.jsp',
                authPrevilege: 'SearchAvailabilityAndPrice'
            },
            {
                title: 'Search Available Space',
                pathname: '/lmsweb/secure/availability.jsp',
                authPrevilege: 'SearchAvailableSpace'
            },
            {
                title: 'Search Air Waybill Stock',
                pathname: '/lmsweb/secure/awb-stock-status.jsp',
                authPrevilege: 'SearchAirWaybillStock'
            },
            {
                title: 'Create / Modify Booking',
                pathname: '/lmsweb/secure/booking-create.jsp',
                authPrevilege: 'CreateModifyBookingOld'
            },
            {
                title: 'Create Multiple Bookings',
                pathname: '/lmsweb/secure/booking-multiple.jsp',
                authPrevilege: 'CreateMultipleBookings'
            },
            {
                title: 'Create / Modify Booking Templates',
                pathname: '/lmsweb/secure/booking-template.jsp',
                authPrevilege: 'CreateModifyBookingTemplates'
            },
            {
                title: 'Create Spreadsheet Bookings',
                pathname: '/lmsweb/secure/multiCarrierXlsxBooking.jsp',
                authPrevilege: 'CreateSpreadsheetBookings'
            },
            {
                title: 'Create Air Waybill Stock Request',
                pathname: '/lmsweb/secure/awb-stock-request.jsp',
                authPrevilege: 'CreateAirWaybillStockRequest'
            },
            {
                title: 'Create Allotment Request',
                pathname: '/lmsweb/secure/requestallotments.jsp',
                authPrevilege: 'CreateAllotmentRequest'
            },
            {
                title: 'View Allotment Status',
                pathname: '/lmsweb/secure/allocation.jsp',
                authPrevilege: 'ViewAllotmentStatus'
            },
            {
                title: 'View Rate Estimate',
                pathname: '/lmsweb/secure/advancedrateestimate.jsp',
                authPrevilege: 'ViewRateEstimate'
            },
            {
                title: 'View Carrier Schedules',
                pathname: '/lmsweb/flight_schedules.jsp',
                authPrevilege: 'ViewCarrierSchedules'
            },
            {
                title: 'Update Air Waybill Status',
                pathname: '/lmsweb/secure/status_update.jsp',
                authPrevilege: 'UpdateAirWaybillStatus'
            }
        ]
    },
    {
        title: 'e-Freight',
        pathname: '/',
        authPrevilege: 'Efreight',
        subMenus: [
            {
                title: 'Create / Retrieve MAWB',
                pathname: '/lmsweb/secure/retrieve-mawb.jsp',
                authPrevilege: 'CreateRetrieveMAWB'
            },
            {
                title: 'Retrieve e-Docs',
                pathname: '/lmsweb/secure/retrieve-edocs.jsp',
                authPrevilege: 'RetrieveeDocs'
            },
            {
                title: 'Create / Modify HAWB',
                pathname: '/lmsweb/secure/customs.jsp',
                authPrevilege: 'CreateModifyHAWB'
            },
            {
                title: 'Create / Modify HAWB Templates',
                pathname: '/lmsweb/secure/hawb-template.jsp?btnHawbList=Y&optUserId=BRANCH',
                authPrevilege: 'CreateModifyHAWBTemplates'
            },
            {
                title: 'Create / Modify PieceID Info',
                pathname: '/lmsweb/secure/piecedetails.jsp',
                authPrevilege: 'CreateModifyPieceIDInfo'
            }
        ]
    },
    {
        title: 'Manage Shipments',
        pathname: '/',
        authPrevilege: 'ManageShipments',
        subMenus: [
            {
                title: 'Track Shipments',
                authPrevilege: 'TrackShipments',
                pathname: '/lmsweb/tracking-awb.jsp'
            },
            {
                title: 'Search Air Waybills',
                authPrevilege: 'SearchAirWaybills',
                pathname: '/lmsweb/secure/tracking-search.jsp'
            },
            {
                title: 'View / Modify Booking',
                authPrevilege: 'ViewModifyBooking',
                pathname: '/lmsweb/secure/booking-modify.jsp'
            },
            {
                title: 'Review Active / Queued Bookings',
                authPrevilege: 'ReviewActiveQueuedBookings',
                pathname: '/lmsweb/secure/booking-summary.jsp'
            },
            {
                title: 'Print Barcode Shipping Label',
                authPrevilege: 'PrintBarcodeShippingLabel',
                pathname: '/lmsweb/secure/booking-print.jsp'
            },
            {
                title: 'Print Shipper Letter Of Instruction',
                authPrevilege: 'PrintShipperLetterOfInstruction',
                pathname: '/lmsweb/secure/booking-printsli.jsp'
            },
            {
                title: 'Make Online Payments',
                authPrevilege: 'MakeOnlinePayments',
                pathname: '/lmsweb/secure/booking-freight.jsp'
            },
            {
                title: 'View Flight Status',
                authPrevilege: 'ViewFlightStatus',
                pathname: '/lmsweb/flight_status.jsp'
            },
            {
                title: 'View Customs Status',
                authPrevilege: 'ViewCustomsStatus',
                pathname: '/lmsweb/customs-status.jsp'
            },
            {
                title: 'View Archived Air Waybill',
                authPrevilege: 'ViewArchivedAirWaybill',
                pathname: '/lmsweb/secure/archivedshipments.jsp'
            },
            {
                title: 'Shipment Release Declaration',
                authPrevilege: 'ShipmentReleaseDeclaration',
                pathname: '/lmsweb/secure/declaration.jsp'
            }
        ]
    },
    {
        title: 'e-Claims',
        pathname: '/',
        authPrevilege: 'eClaims',
        subMenus: [
            {
                title: 'File Damage Report',
                authPrevilege: 'FileDamageReport',
                pathname: '/lmsweb/secure/damagereport.jsp'
            },
            {
                title: 'View Damage Report Status',
                authPrevilege: 'ViewDamageReportStatus',
                pathname: '/lmsweb/secure/damagereportstatus.jsp'
            },
            {
                title: 'Create / Modify Preliminary Claim',
                authPrevilege: 'CreateModifyPreliminaryClaim',
                pathname: '/lmsweb/secure/filepreliminaryclaim.jsp'
            },
            {
                title: 'Create / Modify Final Claim',
                authPrevilege: 'CreateModifyFinalClaim',
                pathname: '/lmsweb/secure/filefinalclaim.jsp'
            }
        ]
    }
]
export const AZ_MENU_ITEMS: TMenuItem[] = [
    {
        title: 'Offers',
        pathname: '/',
        authPrevilege: 'OfferMenu',
        subMenus: [
            {
                title: 'Manage AZ SPOT Rate Offers',
                pathname: '/lmsweb/secure/managespotrate.jsp',
                authPrevilege: 'ManageAZSpotRATEOffers'
            },
            {
                title: 'View AZ SPOT Offer Queue',
                pathname: '/lmsweb/secure/sraqueue.jsp?selCarrier=AZ',
                authPrevilege: 'ViewAZSPOTofferqueue'
            }
        ]
    },
    {
        title: 'Marketplace',
        pathname: `${ENDPOINT.marketPlace}`,
        authPrevilege: 'Marketplace'
    },
    {
        title: 'Booking',
        pathname: '/',
        authPrevilege: 'Booking',
        subMenus: [
            {
                title: 'Book cargo',
                pathname: 'secure/booking',
                authPrevilege: 'CreateModifyBookingNew',
                badge: 'NEW',
                subTitle: 'Easily create and modify bookings',
                divider: true
            },
            {
                title: 'Search Availability and Price',
                pathname: '/lmsweb/secure/advancedrate.jsp',
                authPrevilege: 'SearchAvailabilityAndPrice'
            },
            {
                title: 'Search Available Space',
                pathname: '/lmsweb/secure/availability.jsp',
                authPrevilege: 'SearchAvailableSpace'
            },
            {
                title: 'Search Air Waybill Stock',
                pathname: '/lmsweb/secure/awb-stock-status.jsp',
                authPrevilege: 'SearchAirWaybillStock'
            },
            {
                title: 'Create / Modify Booking',
                pathname: '/lmsweb/secure/booking-create.jsp',
                authPrevilege: 'CreateModifyBookingOld'
            },
            {
                title: 'Create Multiple Bookings',
                pathname: '/lmsweb/secure/booking-multiple.jsp',
                authPrevilege: 'CreateMultipleBookings'
            },
            {
                title: 'Create / Modify Booking Templates',
                pathname: '/lmsweb/secure/booking-template.jsp',
                authPrevilege: 'CreateModifyBookingTemplates'
            },
            {
                title: 'Create Spreadsheet Bookings',
                pathname: '/lmsweb/secure/multiCarrierXlsxBooking.jsp',
                authPrevilege: 'CreateSpreadsheetBookings'
            },
            {
                title: 'Create Air Waybill Stock Request',
                pathname: '/lmsweb/secure/awb-stock-request.jsp',
                authPrevilege: 'CreateAirWaybillStockRequest'
            },
            {
                title: 'Create Allotment Request',
                pathname: '/lmsweb/secure/requestallotments.jsp',
                authPrevilege: 'CreateAllotmentRequest'
            },
            {
                title: 'View Allotment Status',
                pathname: '/lmsweb/secure/allocation.jsp',
                authPrevilege: 'ViewAllotmentStatus'
            },
            {
                title: 'View Rate Estimate',
                pathname: '/lmsweb/secure/advancedrateestimate.jsp',
                authPrevilege: 'ViewRateEstimate'
            },
            {
                title: 'View Carrier Schedules',
                pathname: '/lmsweb/flight_schedules.jsp',
                authPrevilege: 'ViewCarrierSchedules'
            },
            {
                title: 'Update Air Waybill Status',
                pathname: '/lmsweb/secure/status_update.jsp',
                authPrevilege: 'UpdateAirWaybillStatus'
            }
        ]
    },
    {
        title: 'e-Freight',
        pathname: '/',
        authPrevilege: 'Efreight',
        subMenus: [
            {
                title: 'Create / Retrieve MAWB',
                pathname: '/lmsweb/secure/retrieve-mawb.jsp',
                authPrevilege: 'CreateRetrieveMAWB'
            },
            {
                title: 'Create / Modify HAWB',
                pathname: '/lmsweb/secure/customs.jsp',
                authPrevilege: 'CreateModifyHAWB'
            },
            {
                title: 'Create / Modify HAWB Templates',
                pathname: '/lmsweb/secure/hawb-template.jsp?btnHawbList=Y&optUserId=BRANCH',
                authPrevilege: 'CreateModifyHAWBTemplates'
            },
            {
                title: 'Create / Modify PieceID Info',
                pathname: '/lmsweb/secure/piecedetails.jsp',
                authPrevilege: 'CreateModifyPieceIDInfo'
            }
        ]
    },
    {
        title: 'Manage Shipments',
        pathname: '/',
        authPrevilege: 'ManageShipments',
        subMenus: [
            {
                title: 'Track Shipments',
                authPrevilege: 'TrackShipments',
                pathname: '/lmsweb/tracking-awb.jsp'
            },
            {
                title: 'Search Air Waybills',
                authPrevilege: 'SearchAirWaybills',
                pathname: '/lmsweb/secure/tracking-search.jsp'
            },
            {
                title: 'View / Modify Booking',
                authPrevilege: 'ViewModifyBooking',
                pathname: '/lmsweb/secure/booking-modify.jsp'
            },
            {
                title: 'Review Active / Queued Bookings',
                authPrevilege: 'ReviewActiveQueuedBookings',
                pathname: '/lmsweb/secure/booking-summary.jsp'
            },
            {
                title: 'Print Barcode Shipping Label',
                authPrevilege: 'PrintBarcodeShippingLabel',
                pathname: '/lmsweb/secure/booking-print.jsp'
            },
            {
                title: 'Print Shipper Letter Of Instruction',
                authPrevilege: 'PrintShipperLetterOfInstruction',
                pathname: '/lmsweb/secure/booking-printsli.jsp'
            },
            {
                title: 'Make Online Payments',
                authPrevilege: 'MakeOnlinePayments',
                pathname: '/lmsweb/secure/booking-freight.jsp'
            },
            {
                title: 'View Flight Status',
                authPrevilege: 'ViewFlightStatus',
                pathname: '/lmsweb/flight_status.jsp'
            },
            {
                title: 'View Customs Status',
                authPrevilege: 'ViewCustomsStatus',
                pathname: '/lmsweb/customs-status.jsp'
            },
            {
                title: 'View Archived Air Waybill',
                authPrevilege: 'ViewArchivedAirWaybill',
                pathname: '/lmsweb/secure/archivedshipments.jsp'
            },
            {
                title: 'Shipment Release Declaration',
                authPrevilege: 'ShipmentReleaseDeclaration',
                pathname: '/lmsweb/secure/declaration.jsp'
            }
        ]
    },
    {
        title: 'e-Claims',
        pathname: '/',
        authPrevilege: 'eClaims',
        subMenus: [
            {
                title: 'File Damage Report',
                authPrevilege: 'FileDamageReport',
                pathname: '/lmsweb/secure/damagereport.jsp'
            },
            {
                title: 'View Damage Report Status',
                authPrevilege: 'ViewDamageReportStatus',
                pathname: '/lmsweb/secure/damagereportstatus.jsp'
            },
            {
                title: 'Create / Modify Preliminary Claim',
                authPrevilege: 'CreateModifyPreliminaryClaim',
                pathname: '/lmsweb/secure/filepreliminaryclaim.jsp'
            },
            {
                title: 'Create / Modify Final Claim',
                authPrevilege: 'CreateModifyFinalClaim',
                pathname: '/lmsweb/secure/filefinalclaim.jsp'
            }
        ]
    }
]

export const SERVICE_MENU_ITEMS: TMenuItem[] = [
    {
        title: 'Offers',
        pathname: '/',
        authPrevilege: 'OfferMenu',
        subMenus: [
            {
                title: 'Request a SPOT Rate',
                pathname: '/lmsweb/secure/spot_pricing.jsp',
                authPrevilege: 'RequestASpotRate'
            }
        ]
    },
    {
        title: 'Marketplace',
        pathname: `${ENDPOINT.marketPlace}`,
        authPrevilege: 'Marketplace'
    },
    {
        title: 'Booking',
        pathname: '/',
        authPrevilege: 'Booking',
        subMenus: [
            {
                title: 'Book cargo',
                pathname: 'secure/booking',
                authPrevilege: 'CreateModifyBookingNew',
                badge: 'NEW',
                subTitle: 'Easily create and modify bookings',
                divider: true
            },
            {
                title: 'Search Availability and Price',
                pathname: '/lmsweb/secure/advancedrate.jsp',
                authPrevilege: 'SearchAvailabilityAndPrice'
            },
            {
                title: 'Search Available Space',
                pathname: '/lmsweb/secure/availability.jsp',
                authPrevilege: 'SearchAvailableSpace'
            },
            {
                title: 'Search Air Waybill Stock',
                pathname: '/lmsweb/secure/awb-stock-status.jsp',
                authPrevilege: 'SearchAirWaybillStock'
            },
            {
                title: 'Create / Modify Booking',
                pathname: '/lmsweb/secure/booking-create.jsp',
                authPrevilege: 'CreateModifyBookingOld'
            },
            {
                title: 'Create Multiple Bookings',
                pathname: '/lmsweb/secure/booking-multiple.jsp',
                authPrevilege: 'CreateMultipleBookings'
            },
            {
                title: 'Create / Modify Booking Templates',
                pathname: '/lmsweb/secure/booking-template.jsp',
                authPrevilege: 'CreateModifyBookingTemplates'
            },
            {
                title: 'Create Recurring Booking Template',
                pathname: '/lmsweb/secure/recurringbookingtemplate.jsp',
                authPrevilege: 'CreateRecurringBookingTemplate'
            },
            {
                title: 'Create Spreadsheet Bookings',
                pathname: '/lmsweb/secure/multiCarrierXlsxBooking.jsp',
                authPrevilege: 'CreateSpreadsheetBookings'
            },
            {
                title: 'Create Air Waybill Stock Request',
                pathname: '/lmsweb/secure/awb-stock-request.jsp',
                authPrevilege: 'CreateAirWaybillStockRequest'
            },
            {
                title: 'Create Allotment Request',
                pathname: '/lmsweb/secure/requestallotments.jsp',
                authPrevilege: 'CreateAllotmentRequest'
            },
            {
                title: 'View Allotment Status',
                pathname: '/lmsweb/secure/allocation.jsp',
                authPrevilege: 'ViewAllotmentStatus'
            },
            {
                title: 'View Rate Estimate',
                pathname: '/lmsweb/secure/advancedrateestimate.jsp',
                authPrevilege: 'ViewRateEstimate'
            },
            {
                title: 'View Carrier Schedules',
                pathname: '/lmsweb/flight_schedules.jsp',
                authPrevilege: 'ViewCarrierSchedules'
            }
        ]
    },
    {
        title: 'e-Freight',
        pathname: '/',
        authPrevilege: 'Efreight',
        subMenus: [
            {
                title: 'Create / Retrive MAWB',
                pathname: '/lmsweb/secure/retrieve-mawb.jsp',
                authPrevilege: 'CreateRetrieveMAWB'
            },
            {
                title: 'Retrieve e-Docs',
                pathname: '/lmsweb/secure/retrieve-edocs.jsp',
                authPrevilege: 'RetrieveeDocs'
            },
            {
                title: 'Create / Modify HAWB',
                pathname: '/lmsweb/secure/customs.jsp',
                authPrevilege: 'CreateModifyHAWB'
            },
            {
                title: 'Create / Modify HAWB Templates',
                pathname: '/lmsweb/secure/hawb-template.jsp?btnHawbList=Y&optUserId=BRANCH',
                authPrevilege: 'CreateModifyHAWBTemplates'
            },
            {
                title: 'Create / Modify PieceID Info',
                pathname: '/lmsweb/secure/piecedetails.jsp',
                authPrevilege: 'CreateModifyPieceIDInfo'
            }
        ]
    },
    {
        title: 'Manage Shipments',
        pathname: '/',
        authPrevilege: 'ManageShipments',
        subMenus: [
            {
                title: 'Track Shipments',
                authPrevilege: 'TrackShipments',
                pathname: '/lmsweb/tracking-awb.jsp'
            },
            {
                title: 'Search Air Waybills',
                authPrevilege: 'SearchAirWaybills',
                pathname: '/lmsweb/secure/tracking-search.jsp'
            },
            {
                title: 'View / Modify Booking',
                authPrevilege: 'ViewModifyBooking',
                pathname: '/lmsweb/secure/booking-modify.jsp'
            },
            {
                title: 'Review Active / Queued Bookings',
                authPrevilege: 'ReviewActiveQueuedBookings',
                pathname: '/lmsweb/secure/booking-summary.jsp'
            },
            {
                title: 'Print Barcode Shipping Label',
                authPrevilege: 'PrintBarcodeShippingLabel',
                pathname: '/lmsweb/secure/booking-print.jsp'
            },
            {
                title: 'Print Shipper Letter Of Instruction',
                authPrevilege: 'PrintShipperLetterOfInstruction',
                pathname: '/lmsweb/secure/booking-printsli.jsp'
            },
            {
                title: 'Make Online Payments',
                authPrevilege: 'MakeOnlinePayments',
                pathname: '/lmsweb/secure/booking-freight.jsp'
            },
            {
                title: 'View Flight Status',
                authPrevilege: 'ViewFlightStatus',
                pathname: '/lmsweb/flight_status.jsp'
            },
            {
                title: 'View Customs Status',
                authPrevilege: 'ViewCustomsStatus',
                pathname: '/lmsweb/customs-status.jsp'
            },
            {
                title: 'View Archived Air Waybill',
                authPrevilege: 'ViewArchivedAirWaybill',
                pathname: '/lmsweb/secure/archivedshipments.jsp'
            },
            {
                title: 'Shipment Status by Email',
                authPrevilege: 'ShipmentStatusbyEmail',
                pathname: '/lmsweb/tracking-email.jsp'
            },
            {
                title: 'Review Specialized Booking',
                authPrevilege: 'ReviewSpecializedBooking',
                pathname: '/lmsweb/secure/special_booking_details_review.jsp'
            },
            {
                title: 'Shipment Release Declaration',
                authPrevilege: 'ShipmentReleaseDeclaration',
                pathname: '/lmsweb/secure/declaration.jsp'
            }
        ]
    },
    // As per Sabari's confrmation commenting below code for OCT release
    {
        title: 'e-Docs',
        pathname: '/',
        authPrevilege: 'eDocs',
        subMenus: [
            {
                title: 'My Booking Documents',
                authPrevilege: 'MyBookingDocuments',
                pathname: '/lmsweb/secure/document_dashboard_view.jsp'
            },
            {
                title: 'Air Waybill Documents',
                authPrevilege: 'AirWaybillDocuments',
                pathname: '/lmsweb/secure/document_view.jsp'
            }
        ]
    },
    {
        title: 'e-Finance',
        pathname: '/',
        authPrevilege: 'e-Finance',
        subMenus: [
            {
                title: 'View Invoices',
                authPrevilege: 'ViewInvoices',
                pathname: '/lmsweb/secure/invoiceinformation.jsp'
            },
            {
                title: 'View Payment Details',
                authPrevilege: 'ViewPaymentDetails',
                pathname: '/lmsweb/secure/paymentinformation.jsp'
            }
        ]
    },
    {
        title: 'e-Claims',
        pathname: '/',
        authPrevilege: 'eClaims',
        subMenus: [
            {
                title: 'Create / Modify Preliminary Claim',
                authPrevilege: 'CreateModifyPreliminaryClaim',
                pathname: '/lmsweb/secure/filepreliminaryclaim.jsp'
            },
            {
                title: 'Create / Modify Final Claim',
                authPrevilege: 'CreateModifyFinalClaim',
                pathname: '/lmsweb/secure/filefinalclaim.jsp'
            },
            {
                title: 'View AC Claim Status',
                authPrevilege: 'ViewACClaimStatus',
                pathname: '/lmsweb/secure/claimsstatus.jsp?selCarrier=AC'
            },
            {
                title: 'View AI Claim Status',
                authPrevilege: 'ViewAIClaimStatus',
                pathname: '/lmsweb/secure/claimsstatus.jsp?selCarrier=AI'
            },
            {
                title: 'View MH Claim Status',
                authPrevilege: 'ViewMHClaimStatus',
                pathname: '/lmsweb/secure/claimsstatus.jsp?selCarrier=MH'
            },
            {
                title: 'View SK Claim Status',
                authPrevilege: 'ViewSKClaimStatus',
                pathname: '/lmsweb/secure/claimsstatus.jsp?selCarrier=SK'
            }
        ]
    }
]

export const getCarrierPrevilages = (carrierCode: string) => {
    let carrierPrevilageMapping
    switch (carrierCode) {
        case 'AA':
            carrierPrevilageMapping = new Map([...CarrierAdminAA()])
            break
        case 'AC':
            carrierPrevilageMapping = new Map([...CarrierAdminAC()])
            break
        case 'AF-KL':
            carrierPrevilageMapping = new Map([...CarrierAdminAFKL()])
            break
        case 'AI':
            carrierPrevilageMapping = new Map([...CarrierAdminAI()])
            break
        case 'MH':
            carrierPrevilageMapping = new Map([...CarrierAdminMH()])
            break
        case 'NZ':
            carrierPrevilageMapping = new Map([...CarrierAdminNZ()])
            break
        case 'SK':
            carrierPrevilageMapping = new Map([...CarrierAdminSK()])
            break
        case 'UA':
            carrierPrevilageMapping = new Map([...CarrierAdminUA()])
            break
        case 'UW':
            carrierPrevilageMapping = new Map([...CarrierAdminUW()])
            break
        case 'AZ':
            carrierPrevilageMapping = new Map([...CarrierAdminAZ()])
            break
        case 'QR':
            carrierPrevilageMapping = new Map([...CarrierAdminQR()])
            break
        case '8D':
            carrierPrevilageMapping = new Map([...CarrierAdmin8D()])
            break
        default:
            carrierPrevilageMapping = new Map<object, object>()
    }
    return carrierPrevilageMapping
}

export const getCarrierMenuItems = (carrierCode: string) => {
    let CARRIER_MENU_ITEMS: TMenuItem[] = []
    switch (carrierCode) {
        case 'AA':
            CARRIER_MENU_ITEMS = AA_MENU_ITEMS
            break
        case 'AC':
            CARRIER_MENU_ITEMS = AC_MENU_ITEMS
            break
        case 'AF-KL':
            CARRIER_MENU_ITEMS = AF_KL_MENU_ITEMS
            break
        case 'AI':
            CARRIER_MENU_ITEMS = AI_MENU_ITEMS
            break
        case 'MH':
            CARRIER_MENU_ITEMS = MH_MENU_ITEMS
            break
        case 'NZ':
            CARRIER_MENU_ITEMS = NZ_MENU_ITEMS
            break
        case 'SK':
            CARRIER_MENU_ITEMS = SK_MENU_ITEMS
            break
        case 'UA':
            CARRIER_MENU_ITEMS = UA_MENU_ITEMS
            break
        case 'UW':
            CARRIER_MENU_ITEMS = UW_MENU_ITEMS
            break
        case 'AZ':
            CARRIER_MENU_ITEMS = AZ_MENU_ITEMS
            break
        default:
            CARRIER_MENU_ITEMS = MENU_ITEMS
    }
    return CARRIER_MENU_ITEMS
}

export const getCarrierUserManagementPrivileges = (
    carrierCode: string,
    isCarrierAdmin: boolean,
    isSecondLevelCarrierAdmin: boolean
) => {
    const carrierPrevilageMapping = CarrierAdminUserManagementPrevilages().get(carrierCode)
    let carrierUMAccessLevel = deafultCarrierUserManagementPrevilages
    for (const [key, value] of CarrierAdminUserManagementAccess().entries()) {
        if (JSON.stringify(key) === JSON.stringify({isCarrierAdmin, isSecondLevelCarrierAdmin})) {
            carrierUMAccessLevel = value
            break
        }
    }

    const carrierUMAccessLevels = handleCarrierUMMapping(
        carrierPrevilageMapping ?? deafultCarrierUserManagementPrevilages,
        carrierUMAccessLevel
    )

    return carrierUMAccessLevels ?? deafultCarrierUserManagementPrevilages
}

export const getCarrierToolsPrivileges = (
    carrierCode: string,
    isCarrierAdmin: boolean,
    isSecondLevelCarrierAdmin: boolean
) => {
    const carrierPrevilageMapping = CarrierAdminToolsPrevilages().get(carrierCode)
    let carrierToolsAccessLevel = deafultCarrierToolsPrevilages
    for (const [key, value] of CarrierAdminToolsAccess().entries()) {
        if (JSON.stringify(key) === JSON.stringify({isCarrierAdmin, isSecondLevelCarrierAdmin})) {
            carrierToolsAccessLevel = value
            break
        }
    }

    const carrierToolsAccessLevels = handleCarrierToolsMapping(
        carrierPrevilageMapping ?? deafultCarrierToolsPrevilages,
        carrierToolsAccessLevel
    )

    return carrierToolsAccessLevels ?? deafultCarrierToolsPrevilages
}

const handleCarrierUMMapping = (
    carrierPrivilege: ICarrierAdminUserManagementAuthorizationConfig,
    accessConfig: ICarrierAdminUserManagementAuthorizationConfig
) => {
    let carrierUMPrivileges: ICarrierAdminUserManagementAuthorizationConfig
    if (carrierPrivilege) {
        carrierUMPrivileges = {
            ...carrierPrivilege,
            isManageMyProfile:
                carrierPrivilege.isManageMyProfile === 'Enabled' && accessConfig.isManageMyProfile === 'Enabled'
                    ? 'Enabled'
                    : 'Disabled',
            isManageBranchAccess:
                carrierPrivilege.isManageBranchAccess === 'Enabled' && accessConfig.isManageBranchAccess === 'Enabled'
                    ? 'Enabled'
                    : 'Disabled',
            isManageCarrierProfile:
                carrierPrivilege.isManageCarrierProfile === 'Enabled' &&
                accessConfig.isManageCarrierProfile === 'Enabled'
                    ? 'Enabled'
                    : 'Disabled',
            isManageCarrierUsers:
                carrierPrivilege.isManageCarrierUsers === 'Enabled' && accessConfig.isManageCarrierUsers === 'Enabled'
                    ? 'Enabled'
                    : 'Disabled',
            isCreateCarrierUser:
                carrierPrivilege.isCreateCarrierUser === 'Enabled' && accessConfig.isCreateCarrierUser === 'Enabled'
                    ? 'Enabled'
                    : 'Disabled'
        }
        return carrierUMPrivileges
    }
}

const handleCarrierToolsMapping = (
    carrierPrivilege: ICarrierAdminToolsAuthorizationConfig,
    accessConfig: ICarrierAdminToolsAuthorizationConfig
) => {
    let carrierToolsPrivileges: ICarrierAdminToolsAuthorizationConfig
    if (carrierPrivilege) {
        carrierToolsPrivileges = {
            ...carrierPrivilege,
            isManageErrorMessages:
                carrierPrivilege.isManageErrorMessages === 'Enabled' && accessConfig.isManageErrorMessages === 'Enabled'
                    ? 'Enabled'
                    : 'Disabled',
            isHosttoHostTranslations:
                carrierPrivilege.isHosttoHostTranslations === 'Enabled' &&
                accessConfig.isHosttoHostTranslations === 'Enabled'
                    ? 'Enabled'
                    : 'Disabled',
            isRestrictProducts:
                carrierPrivilege.isRestrictProducts === 'Enabled' && accessConfig.isRestrictProducts === 'Enabled'
                    ? 'Enabled'
                    : 'Disabled',
            isSpecializedBookingDatasetup:
                carrierPrivilege.isSpecializedBookingDatasetup === 'Enabled' &&
                accessConfig.isSpecializedBookingDatasetup === 'Enabled'
                    ? 'Enabled'
                    : 'Disabled',
            isURNIATAAccountMapping:
                carrierPrivilege.isURNIATAAccountMapping === 'Enabled' &&
                accessConfig.isURNIATAAccountMapping === 'Enabled'
                    ? 'Enabled'
                    : 'Disabled',
            isUploadProductSelector:
                carrierPrivilege.isUploadProductSelector === 'Enabled' &&
                accessConfig.isUploadProductSelector === 'Enabled'
                    ? 'Enabled'
                    : 'Disabled',
            isManageSpecializedBookings:
                carrierPrivilege.isManageSpecializedBookings === 'Enabled' &&
                accessConfig.isManageSpecializedBookings === 'Enabled'
                    ? 'Enabled'
                    : 'Disabled',
            isManageOffers:
                carrierPrivilege.isManageOffers === 'Enabled' && accessConfig.isManageOffers === 'Enabled'
                    ? 'Enabled'
                    : 'Disabled'
        }
        return carrierToolsPrivileges
    }
}
